// Relationships for sign up flow
export enum RelationshipStatus {
  SPOUSE = "spouse",
  PARENT = "parent",
  SIBLING = "sibling",
  RELATIVE = "relative",
  FRIEND = "Friend",
  EX_SPOUSE = "ExSpouse",
  EXTENDED_FAMILY = "ExtendedFamily",
  BUSINESS_PARTNER = "BusinessPartner",
  NONE_OF_THESE = "other",
  OTHER = "other",
}

export const relationshipOptions = [
  { label: "Spouse", value: RelationshipStatus.SPOUSE },
  { label: "Sibling", value: RelationshipStatus.SIBLING },
  { label: "Parent", value: RelationshipStatus.PARENT },
  { label: "Relative", value: RelationshipStatus.RELATIVE },
  { label: "Friend", value: RelationshipStatus.FRIEND },
  { label: "Ex-spouse", value: RelationshipStatus.EX_SPOUSE },
  { label: "Extended family", value: RelationshipStatus.EXTENDED_FAMILY },
  { label: "Business partner", value: RelationshipStatus.BUSINESS_PARTNER },
  { label: "None of these", value: RelationshipStatus.OTHER },
];

// Relationships for gift fund giver relationships
export enum GIFT_RelationshipStatus {
  SPOUSE = "spouse",
  PARENT = "parent",
  GRAND_PARENT = "grandparent",
  AUNT_UNCLE = "aunt_uncle",
  SIBLING = "sibling",
  COUSIN = "cousin",
  FIANCE = "fiance",
  DOMESTIC_PARTNER = "domestic_partner",
  CHILD = "child",
}

export const giftRelationshipOptions = [
  { label: "Spouse", value: GIFT_RelationshipStatus.SPOUSE },
  { label: "Sibling", value: GIFT_RelationshipStatus.SIBLING },
  { label: "Parent", value: GIFT_RelationshipStatus.PARENT },
  { label: "Grandparent", value: GIFT_RelationshipStatus.GRAND_PARENT },
  { label: "Aunt / Uncle", value: GIFT_RelationshipStatus.AUNT_UNCLE },
  { label: "Cousin", value: GIFT_RelationshipStatus.COUSIN },
  { label: "Fiancé/Fiancée", value: GIFT_RelationshipStatus.FIANCE },
  { label: "Domestic Partner", value: GIFT_RelationshipStatus.DOMESTIC_PARTNER },
  { label: "Child", value: GIFT_RelationshipStatus.CHILD },
];
